import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styles from './PrimeiroAcesso.scss';
import LoginBackground from './../../assets/images/logo_programas_educacionais.png';
import { openModal } from '../../store/modules/ModalActions';
import PrimeiroAcessoModal from '../../components/PrimeiroAcessoModal/PrimeiroAcessoModal';
import { getApis } from 'library/Apis';
import AuthService from 'services/Auth/AuthService';

const rootClassName = styles.rootClassName;

const PrimeiroAcesso: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { logout } = AuthService();

  const getCpfFromURL = (): string | null => {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get('user') || null;
  };

  const redirectToLogin = (): void => {
    const { authUrl, clientID, redirectUrl } = getApis().auth;
    const loginUrl = `${authUrl}?client_id=${clientID}&redirect_uri=${encodeURIComponent(
      redirectUrl
    )}&origin=external&response_type=id_token%20token&scope=openid%20profile%20email`;
    window.location.href = loginUrl;
  };

  useEffect(() => {
    const user = getCpfFromURL();
    dispatch(
      openModal(PrimeiroAcessoModal, {
        modalKey: 'PrimeiroAcessoModal',
        cpf: user,
        cancelCallback: () => {
          logout();
        },
        savedCallback: () => {
          redirectToLogin();
        },
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <div
      className={rootClassName}
      style={{
        backgroundImage: `url(${LoginBackground})`,
      }}
    ></div>
  );
};

export default PrimeiroAcesso;
